RA.KBSearch = {
  searchUrl: Config.contextPath + "/controller/search/json",
  showBrowseHits: false,
  showDidYouMean: false,
  showHitSummary: true,
  showRelevancyStars: true,
  filterApplied: false,
  query: {},

  getShowCollectionFilter() {
	  return Config.showCollectionFilter;
  },getShowAttributeFilter() {
	  return Config.showAttributeFilter;
  },getShowFavoriteFilter() {
    return Config.maxSearchableFavorites > 0;
  },isAiChatEnabled() {
    return Config.aiChatIsEnabled;
  },
  getAiAnswerGenerationUrl() {
    return Config.aiAnswerGenerationUrl;
  },
  search(query, callback, extraParams) {
    this.query = query;

    let data = $.extend({}, this.query);
    if (extraParams) {
      $.extend(data, extraParams);
    }

    $.get(this.searchUrl, data)
      .done(res => {
        res.preventChatTrigger = extraParams && extraParams.doSearchLogging === false;
        callback(res);
      })
      .fail(RA.handleInvisibleAjaxError);
  },
  applyFilter(filter, callback, extraParams) {
    $.extend(this.query, filter);
    this.filterApplied = true;
    // Reset page and remove any empty query params
    delete this.query.currentpage;
    for (let key in this.query) {
      if (this.query[key] === "") {
        delete this.query[key];
      }
    }

    if (!extraParams) {
      extraParams = {isbrowse: true};
    }

    this.search(this.query, callback, extraParams);
  },
  resetFilters(callback) {
    let queryText = this.query.querytext;

    this.query = {};

    if (queryText != undefined && queryText.length) {
      this.query.querytext = queryText;
    }

    this.applyFilter(this.query, callback);
  },
  
  resetNonFederatedRakeTabFilters(callback, extraParams) {
    let queryText = this.query.querytext;

    this.query = {};

    if (queryText != undefined && queryText.length) {
      this.query.querytext = queryText;
    }

    this.applyFilter(this.query, callback, extraParams);
  },
  
  loadPage(num, callback) {
    this.query.currentpage = num;
    this.search(this.query, callback);
  },

  nonFederatedRakeLoadPage(num, callback, extraParams) {
    this.query.currentpage = num;
    this.search(this.query, callback, extraParams);
  },
  
  isFilterApplied(): boolean {
    return !Object.keys(this.query).every(key => {
      return key == "querytext" || key == "currentpage" || this.query[key] === ""
    });
  }
};

RA.CommunitySearch = Object.create(RA.KBSearch);
$.extend(RA.CommunitySearch, {
  searchUrl: Config.contextPath + "/controller/socialsearch/json"
});

RA.RakeNonFederatedSearch = Object.create(RA.KBSearch);
$.extend(RA.RakeNonFederatedSearch, {
  searchUrl: Config.contextPath + "/controller/nonfederatedrakesearch/json"
});
